import axios from 'axios';
var ajaxUrl5100 = window.location.protocol + "//";
var ajaxUrl6100 = window.location.protocol + "//";
var ajaxUrl7100 = window.location.protocol + "//";
var ajaxUrl8100 = window.location.protocol + "//";
var ajaxUrl9100 = window.location.protocol + "//";
if (window.location.hostname == 'm.yiliangkeji.cn') {
    ajaxUrl5100 += "xsb-api-server.yiliangkeji.cn/robot";
    ajaxUrl6100 += "xsb-api-server.yiliangkeji.cn/backend";
    ajaxUrl7100 += "xsb-api-server.yiliangkeji.cn/weixin";
    ajaxUrl8100 += "xsb-boss-server.yiliangkeji.cn/backend";
    ajaxUrl9100 += "xsb-boss-server.yiliangkeji.cn/weixin";
} else if (window.location.hostname == "appfile.yiliangkeji.cn") {
    ajaxUrl5100 += "xsb-api-server.yiliangkeji.cn/robot";
    ajaxUrl6100 += "xsb-api-server.yiliangkeji.cn/backend";
    ajaxUrl7100 += "xsb-api-server.yiliangkeji.cn/weixin";
    ajaxUrl8100 += "xsb-boss-server.yiliangkeji.cn/backend";
    ajaxUrl9100 += "xsb-boss-server.yiliangkeji.cn/weixin";
} else if (window.location.hostname == "m.yunkeweidian.com") {
    ajaxUrl5100 += "xsb-api-server.yiliangkeji.cn/robot";
    ajaxUrl6100 += "xsb-api-server.yiliangkeji.cn/backend";
    ajaxUrl7100 += "xsb-api-server.yiliangkeji.cn/weixin";
    ajaxUrl8100 += "xsb-boss-server.yiliangkeji.cn/backend";
    ajaxUrl9100 += "xsb-boss-server.yiliangkeji.cn/weixin";
} else {
    ajaxUrl5100 += "xsb-api-server.api.k8s.yunkeweidian.com/robot";
    ajaxUrl6100 += "xsb-api-server.api.k8s.yunkeweidian.com/backend";
    ajaxUrl7100 += "xsb-api-server.api.k8s.yunkeweidian.com/weixin";
    ajaxUrl8100 += "xsb-boss-server.api.k8s.yunkeweidian.com/backend";
    ajaxUrl9100 += "xsb-boss-server.api.k8s.yunkeweidian.com/weixin";
}
/*移动端*/

export const getOpenId = params => { return axios.get(ajaxUrl7100 + '/bandWeixin/getOpenId' + params); };
export const getOrganizationByOpenId = params => { return axios.post(ajaxUrl6100 + '/organization/getOrganizationByOpenId' + params); };
export const toPayByJSapi = params => { return axios.post(ajaxUrl6100 + '/pay/toPayByJSapi', params); };
export const bandOpenId = params => { return axios.post(ajaxUrl6100 + '/organization/bandOpenId' + params); };
export const getRechargePhoneBillList = params => { return axios.post(ajaxUrl6100 + '/organization/getRechargePhoneBillList', params); };
export const getIsFirstRecharge = params => { return axios.post(ajaxUrl6100 + '/organization/getIsFirstRecharge', params); };
export const getTaskProgressByOrganizationId = params => { return axios.post(ajaxUrl5100 + '/moblieTotalAccountSurvey/getTaskProgressByOrganizationId' + params); };
export const moblieSurveyStatistics = params => { return axios.post(ajaxUrl5100 + '/moblieTotalAccountSurvey/moblieSurveyStatistics', params); };
export const updateFollowStatusAndRemarkByRecordId = params => { return axios.post(ajaxUrl5100 + '/calltask/updateFollowStatusAndRemarkByRecordId', params); };
// 跟据主从账号机构id获取AB类线索列表
export const getAbClueList = params => { return axios.post(ajaxUrl5100 + '/organizationClue/getAbClueList', params); };
export const getTaskListByOrganizationId = params => { return axios.post(ajaxUrl5100 + '/calltask/getTaskListByOrganizationId' + params); };
// APP电销卫士主页查询
export const queryImportMainPage = params => { return axios.post(ajaxUrl5100 + '/importRecords/queryImportMainPage'); };
// APP电销卫士查询导入更多
export const queryImportPage = params => { return axios.post(ajaxUrl5100 + '/importRecords/queryImportPage', params); };
/*移动端*/
/*6100服务*/
// 查询最新版本
export const getVersionUpgradeInfo = params => { return axios.post(ajaxUrl6100 + '/upgrade/getVersionUpgradeInfo' + params); };
export const getGeetParm = params => { return axios.get(ajaxUrl6100 + '/geetest/getParams' + params); };
export const getArtificialCallOutAuth = params => { return axios.post(ajaxUrl6100 + '/roleController/getArtificialCallOutAuth' + params); };
// 申请试用
export const applyTest = params => { return axios.post(ajaxUrl6100 + '/organizationTest/applyTest', params); };
export const applyTestList = params => { return axios.post(ajaxUrl6100 + '/organizationTest/applyTestList', params); };
export const applyTestFollowUp = params => { return axios.post(ajaxUrl6100 + '/organizationTest/applyTestFollowUp', params); };
export const getPayParam = params => { return axios.post(ajaxUrl6100 + '/pay/getPayParam', params); };
// 登录
export const login = params => { return axios.get(ajaxUrl6100 + '/loginController/login' + params); };
// 获取token
export const getToken = params => { return axios.get(ajaxUrl6100 + '/loginController/getUserInfoByToken' + params); };
// 获取验证码
export const getMsgCode = params => { return axios.get(ajaxUrl6100 + '/loginController/msgCode' + params); };
// 新获取验证码
export const getMsgTestCode = params => { return axios.post(ajaxUrl8100 + '/organizationTest/msgCode' + params); };
// 邀请码验证
export const verificationInvitationCode = params => { return axios.post(ajaxUrl6100 + '/loginController/verificationInvitationCode' + params); };
// 注册
export const register = params => { return axios.post(ajaxUrl6100 + '/loginController/register', params); };
// 验证手机号是否注册verificationAccount
export const verificationAccount = params => { return axios.post(ajaxUrl6100 + '/loginController/verificationAccount' + params); };
// 修改密码
export const changePassword = params => { return axios.post(ajaxUrl6100 + '/loginController/changePassword' + params); };
// 获取我的菜单
export const getMyMenu = params => { return axios.get(ajaxUrl6100 + '/menuController/getTreeByroleId' + params); };
// 获取机构信息
export const getOrganizationVersionInfoById = params => { return axios.get(ajaxUrl6100 + '/organization/getOrganizationVersionInfoById' + params); };
// 获取机构菜单
export const getOrganizationMenu = params => { return axios.get(ajaxUrl6100 + '/menuController/getTreeByOrganizationId' + params); };
// 获取菜单列表
export const getMenuList = params => { return axios.get(ajaxUrl6100 + '/menuController/list' + params); };
// 添加菜单
export const createMenu = params => { return axios.post(ajaxUrl6100 + '/menuController/save', params); };
//删除菜单
export const delMenu = params => { return axios.post(ajaxUrl6100 + '/menuController/remove' + params); };
/*机构管理*/
// 通过登录用户获取机构详情
export const getOrganizationDetail = params => { return axios.post(ajaxUrl6100 + '/organization/getOrganizationDetail'); };
// 获取机构列表
export const getMechanismList = params => { return axios.post(ajaxUrl6100 + '/organization/list', params); };
// 新增或者编辑机构信息
export const updataMechanism = params => { return axios.post(ajaxUrl6100 + '/organization/save', params); };
// 机构状态管理
export const updataMechanismStatus = params => { return axios.post(ajaxUrl6100 + '/organization/statusOperation' + params); };
// 机构主叫号码查询
export const organizationCallAccountList = params => { return axios.post(ajaxUrl6100 + '/organization/organizationCallAccountList' + params); };
// 添加外呼账号
export const saveOrganizationCallAccount = params => { return axios.post(ajaxUrl6100 + '/organization/saveOrganizationCallAccount', params); };
// 删除外呼账号
export const delOrganizationCallAccount = params => { return axios.post(ajaxUrl6100 + '/organization/delOrganizationCallAccount' + params); };
/**坐席列表**/
export const callGroupUserList = params => { return axios.post(ajaxUrl6100 + '/callGroupUser/list', params); };
export const selectUnboundGroupUserList = params => { return axios.post(ajaxUrl6100 + '/callGroupUser/selectUnboundGroupUserList', params); };
export const saveCallGroupUser = params => { return axios.post(ajaxUrl6100 + '/callGroupUser/saveCallGroupUser' + params); };
export const deleteCallGroupUser = params => { return axios.post(ajaxUrl6100 + '/callGroupUser/deleteCallGroupUser' + params); };
export const getSeatGroup = params => { return axios.post(ajaxUrl6100 + '/groupExNumber/list'); };
export const updataSeatGroup = params => { return axios.post(ajaxUrl6100 + '/groupExNumber/save', params); };
export const selectTeamLeader = params => { return axios.post(ajaxUrl6100 + '/groupExNumber/selectTeamLeader' + params); };
export const removeGroupLeader = params => { return axios.post(ajaxUrl6100 + '/groupExNumber/removeGroupLeader' + params); };
export const addGroupUser = params => { return axios.post(ajaxUrl6100 + '/groupExNumber/addGroupUser' + params); };
export const deleteGroup = params => { return axios.post(ajaxUrl6100 + '/groupExNumber/deleteGroup' + params); };
// 系统通知
export const noticeList = params => { return axios.post(ajaxUrl6100 + '/noticeController/noticeList' + params); };
export const sendNotice = params => { return axios.post(ajaxUrl6100 + '/noticeController/sendNotice', params); };
export const deleteNotice = params => { return axios.post(ajaxUrl6100 + '/noticeController/deleteNotice' + params); };
export const getPageOrganizationNotice = params => { return axios.post(ajaxUrl6100 + '/noticeController/getPageOrganizationNotice'); };
export const readOrganizationNotice = params => { return axios.post(ajaxUrl6100 + '/noticeController/readOrganizationNotice' + params); };

/*机构管理end*/
// 获取登录账户
export const getUserList = params => { return axios.get(ajaxUrl6100 + '/userController/getUserList' + params); };
// 创建登录账户
export const createUser = params => { return axios.post(ajaxUrl6100 + '/userController/save', params); };
// 删除登录用户
export const delUser = params => { return axios.post(ajaxUrl6100 + '/userController/del', params); };
// 修改用户状态
export const updateUserStatic = params => { return axios.post(ajaxUrl6100 + '/userController/statusOperation' + params); };
//修改用户姓名或角色信息
export const updateUser = params => { return axios.post(ajaxUrl6100 + '/userController/update', params); };
// 获取角色列表
export const getRoleList = params => { return axios.get(ajaxUrl6100 + '/roleController/list' + params); };
// 新建角色信息
export const crearRole = params => { return axios.post(ajaxUrl6100 + '/roleController/save', params); };

export const editRole = params => { return axios.post(ajaxUrl6100 + '/roleController/update', params); };
// 删除角色信息
export const delRole = params => { return axios.get(ajaxUrl6100 + '/roleController/remove' + params); };

// 上传图片
export const uploadImg = params => { return axios.post(ajaxUrl6100 + '/uploadController/uploadImg', params); };
// 线路配置
export const selectALinedPool = params => { return axios.post(ajaxUrl6100 + '/aLinedPool/selectALinedPool' + params); };
export const importALinedPool = params => { return axios.post(ajaxUrl6100 + '/aLinedPool/importALinedPool' + params); };
// 更新线路
export const updateALinedPool = params => { return axios.post(ajaxUrl6100 + '/aLinedPool/updateALinedPool', params); };
// 删除线路
export const deleteALinedPool = params => { return axios.post(ajaxUrl6100 + '/aLinedPool/deleteALinedPool' + params); };

// 机构提交认证
export const organizationCertification = params => { return axios.post(ajaxUrl6100 + '/organizationCertification/save', params); };
export const organizationCertificationDetail = params => { return axios.post(ajaxUrl6100 + '/organizationCertification/organizationCertificationDetailByOrganizationId' + params); };
export const organizationCertificationList = params => { return axios.post(ajaxUrl6100 + '/organizationCertification/list', params); };
export const organizationCertificationInspect = params => { return axios.post(ajaxUrl6100 + '/organizationCertification/inspect', params); };
// 外呼设置
export const callsetadd = params => { return axios.post(ajaxUrl6100 + '/organizationCallSet/add', params); };
export const callsetdel = params => { return axios.post(ajaxUrl6100 + '/organizationCallSet/delete' + params); };
export const callsetlist = params => { return axios.post(ajaxUrl6100 + '/organizationCallSet/list', params); };

// 推送设置
export const getCluePushSet = params => { return axios.post(ajaxUrl6100 + '/organizationCluePushSet/getCluePushSet' + params); };
export const saveOrganizationCluePushSet = params => { return axios.post(ajaxUrl6100 + '/organizationCluePushSet/saveOrganizationCluePushSet', params); };

export const updateOrganizationExportPermission = params => { return axios.post(ajaxUrl6100 + '/organization/updateOrganizationExportPermission' + params); };
// 问题反馈
export const organizationFeedback = params => { return axios.post(ajaxUrl6100 + '/problemFeedback/organizationFeedback', params); };
export const queryOrgProblemFeedback = params => { return axios.post(ajaxUrl6100 + '/problemFeedback/queryOrgProblemFeedback' + params); };
export const querySysProblemFeedback = params => { return axios.post(ajaxUrl6100 + '/problemFeedback/querySysProblemFeedback', params); };
export const deleteFeedback = params => { return axios.post(ajaxUrl6100 + '/problemFeedback/deleteFeedback' + params); };
export const queryProblemFeedbackDetail = params => { return axios.post(ajaxUrl6100 + '/problemFeedback/queryProblemFeedbackDetail' + params); };
export const customerReply = params => { return axios.post(ajaxUrl6100 + '/problemFeedback/customerReply', params); };
export const readeProblemFeedbackDetail1 = params => { return axios.post(ajaxUrl6100 + '/problemFeedback/readeProblemFeedbackDetail1' + params); };
// 品类
export const queryCategoryTree = params => { return axios.post(ajaxUrl6100 + '/category/queryCategoryTree'); };
export const addCategory = params => { return axios.post(ajaxUrl6100 + '/category/addCategory', params); };
export const updateCategory = params => { return axios.post(ajaxUrl6100 + '/category/updateCategory', params); };
export const queryParentCategory = params => { return axios.post(ajaxUrl6100 + '/category/queryParentCategory' + params); };
export const homePageQueryCategoryTree = params => { return axios.post(ajaxUrl6100 + '/category/homePageQueryCategoryTree'); };
// 话术市场
export const queryTalkMarketBackend = params => { return axios.post(ajaxUrl6100 + '/talkMarket/queryTalkMarketBackend', params); };
export const queryTalkMarketByCategory = params => { return axios.post(ajaxUrl6100 + '/talkMarket/queryTalkMarketByCategory', params); };
export const createTalkMarket = params => { return axios.post(ajaxUrl6100 + '/talkMarket/createTalkMarket', params); };
export const updateTalkMarket = params => { return axios.post(ajaxUrl6100 + '/talkMarket/updateTalkMarket', params); };
export const updateTalkMarketUpAndDown = params => { return axios.post(ajaxUrl6100 + '/talkMarket/updateTalkMarketUpAndDown', params); };
export const toPayTalkMarket = params => { return axios.post(ajaxUrl6100 + '/pay/toPayTalkMarket' + params); };
// 订单
export const queryOrder = params => { return axios.post(ajaxUrl6100 + '/orderManager/queryOrder', params); };
export const orderDetail = params => { return axios.post(ajaxUrl6100 + '/orderManager/orderDetail' + params); };
export const saveManualOrder = params => { return axios.post(ajaxUrl6100 + '/orderManager/saveManualOrder', params); };
export const exportOrder = params => { return axios.post(ajaxUrl6100 + '/orderManager/exportOrder', params); };

// /organization/getOrganizationInfoByPhone
export const getOrganizationInfoByPhone = params => { return axios.post(ajaxUrl6100 + '/organization/getOrganizationInfoByPhone' + params); };


/*5100服务*/
// 存在待审核数据的机构列表
export const organizationClueCheck = params => { return axios.post(ajaxUrl5100 + '/organizationClueCheck/list', params); };
export const organizationClueCheckRecordList = params => { return axios.post(ajaxUrl5100 + '/organizationClueCheck/organizationClueCheckRecordList', params); };
export const checkRecord = params => { return axios.post(ajaxUrl5100 + '/organizationClueCheck/checkRecord', params); };
// 机构线索库列表页查询
export const getImportDataList = params => { return axios.post(ajaxUrl5100 + '/organizationClue/list', params); };
// 我的线索列表查询
export const getMyImportDataList = params => { return axios.post(ajaxUrl5100 + '/organizationClue/clueList', params); };
// 线索领取-分配-删除
export const clueOperation = params => { return axios.post(ajaxUrl5100 + '/organizationClue/operation', params); };
// 线索转让-放弃
export const myClueOperation = params => { return axios.post(ajaxUrl5100 + '/organizationClue/myClueOperation', params); };
// 线索操作记录
export const clueOperationRecord = params => { return axios.post(ajaxUrl5100 + '/organizationClue/clueOperationRecord', params); };
// 查询来源列表
export const importSourceList = params => { return axios.post(ajaxUrl5100 + '/importSource/list', params); };
// 添加来源
export const addImportSource = params => { return axios.post(ajaxUrl5100 + '/importSource/save', params); };
// 修改来源状态
export const updateImportSource = params => { return axios.post(ajaxUrl5100 + '/importSource/stateOperation', params); };
// 获取转让列表
export const getAssignList = params => { return axios.post(ajaxUrl5100 + '/clueTransfer/list', params); };
// 添加转让
export const addAssign = params => { return axios.post(ajaxUrl5100 + '/clueTransfer/save', params); };
// 删除转让
export const delAssign = params => { return axios.post(ajaxUrl5100 + '/clueTransfer/delete' + params); };
// 获取导入记录列表
export const getImportRecordsList = params => { return axios.post(ajaxUrl5100 + '/importRecords/list', params); };
// 获取导入号码记录列表
export const getImportRecordsNumberList = params => { return axios.post(ajaxUrl5100 + '/importRecords/importRecordsNumberList', params); };
// 添加单条线索
export const addOneClue = params => { return axios.post(ajaxUrl5100 + '/organizationClue/addOneClue', params); };
// 获取外呼账号列表
export const getOrganizationCallAccountList = params => { return axios.post(ajaxUrl6100 + '/organization/organizationCallAccountList' + params); };
// 获取AI线路
export const getAILineList = params => { return axios.post(ajaxUrl5100 + '/robotApiController/lineList' + params); };
// 获取话术模板列表
export const getTemplateList = params => { return axios.post(ajaxUrl5100 + '/robotApiController/templateList' + params); };
// 创建人工外呼任务
export const createTask = params => { return axios.post(ajaxUrl5100 + '/groupExNumberController/createTask', params); };
export const createTask191118 = params => { return axios.post(ajaxUrl5100 + '/calltask/createTask191118', params); };
// 通过任务id获取坐席列表
export const getGroupListByCallTaskId = params => { return axios.post(ajaxUrl5100 + '/calltask/getGroupListByCallTaskId' + params); };
// 创建AI外呼任务
export const AICreateTask = params => { return axios.post(ajaxUrl5100 + '/robotApiController/createTask', params); };
export const missedNumberOneKeyOutboundCall = params => { return axios.post(ajaxUrl5100 + '/robotApiController/missedNumberOneKeyOutboundCall' + params); };
// 获取任务列表
export const getTaskList = params => { return axios.post(ajaxUrl5100 + '/calltask/getTaskList' + params); };
// 开始任务
export const startTask = params => { return axios.post(ajaxUrl5100 + '/groupExNumberController/startTask', params); };
// 暂停任务
export const pauseTask = params => { return axios.post(ajaxUrl5100 + '/groupExNumberController/pauseTask' + params); };
// 结束任务
export const stopTask = params => { return axios.post(ajaxUrl5100 + '/groupExNumberController/stopTask' + params); };
// 更新AI任务状态
export const AIUpdateSaskStatic = params => { return axios.post(ajaxUrl5100 + '/robotApiController/stopOrStartTask' + params); };
export const deleteTask = params => { return axios.post(ajaxUrl5100 + '/robotApiController/deleteTask' + params); };
// 任务号码分页列表
export const getTaskNumberList = params => { return axios.post(ajaxUrl5100 + '/calltask/getTaskNumberList', params); };
// 编辑任务号码详情
export const editTaskNumberInfo = params => { return axios.post(ajaxUrl5100 + '/calltask/editTaskNumberInfo', params); };
// 通过任务号码id获取任务号码详情
export const getTaskNumberDetail = params => { return axios.post(ajaxUrl5100 + '/calltask/getTaskNumberDetail' + params); };
export const editClueNumberInfo = params => { return axios.post(ajaxUrl5100 + '/calltask/editClueNumberInfo', params); };
export const editNumberInfo = params => { return axios.post(ajaxUrl5100 + '/calltask/editNumberInfo', params); };
export const getNumberInfo = params => { return axios.post(ajaxUrl5100 + '/calltask/getNumberInfo' + params); };
// AI外呼任务详情
export const getAiTaskDetail = params => { return axios.post(ajaxUrl5100 + '/robotApiController/aiTaskDetail' + params); };
export const newAiTaskDetail = params => { return axios.post(ajaxUrl5100 + '/robotApiController/newAiTaskDetail' + params); };
// 概况信息
export const getSurveyList = params => { return axios.post(ajaxUrl5100 + '/survey/getSurveyList' + params); };
// 获取系统机构线索总量概况
export const getSystemOrganizationClueTotalData = params => { return axios.post(ajaxUrl5100 + '/survey/getSystemOrganizationClueTotalData', params); };
// 呼叫统计
export const organizationCallStatistics = params => { return axios.post(ajaxUrl5100 + '/survey/organizationCallStatistics', params); };
// 线索统计
export const organizationClueStatistics = params => { return axios.post(ajaxUrl5100 + '/survey/organizationClueStatistics', params); };
// 话费统计
export const organizationPhoneBillStatistics = params => { return axios.post(ajaxUrl5100 + '/survey/organizationPhoneBillStatistics', params); };
// 机构线索库概况
export const organizationSurvey = params => { return axios.post(ajaxUrl5100 + '/organizationClue/organizationSurvey', params); };
// 获取最近一次上传记录
export const lastImportRecords = params => { return axios.post(ajaxUrl5100 + '/organizationClue/lastImportRecords', params); };
// 我的线索概况
export const userSurvey = params => { return axios.post(ajaxUrl5100 + '/organizationClue/userSurvey', params); };
// 机构报表概览
export const organizationReportStatistics = params => { return axios.post(ajaxUrl5100 + '/survey/organizationReportStatistics', params); };
export const newOrganizationSurveyStatistics = params => { return axios.post(ajaxUrl5100 + '/survey/newOrganizationSurveyStatistics', params); };
export const invitationIntentionStatistics = params => { return axios.post(ajaxUrl5100 + '/survey/invitationIntentionStatistics', params); };
export const organizationClueCallStatistics = params => { return axios.post(ajaxUrl5100 + '/survey/organizationClueCallStatistics', params); };
// 坐席状态修改
// 小休
export const agentPause = params => { return axios.post(ajaxUrl5100 + '/groupExNumberController/agentPause' + params); };
// 上线
export const agentOnLine = params => { return axios.post(ajaxUrl5100 + '/groupExNumberController/agentOnLine' + params); };
// 下线
export const agentOffLine = params => { return axios.post(ajaxUrl5100 + '/groupExNumberController/agentOffLine' + params); };
// 获取当前坐席状态
export const getLoginUserGroupStatus = params => { return axios.post(ajaxUrl6100 + '/callGroupUser/getLoginUserGroupStatus'); };
export const modifyTask = params => { return axios.post(ajaxUrl5100 + '/groupExNumberController/modifyTask', params); };

// 总账号概况
export const totalAccountSurveyStatistics = params => { return axios.post(ajaxUrl5100 + '/totalAccountSurvey/totalAccountSurveyStatistics'); };
export const totalAccountSurveyClueList = params => { return axios.post(ajaxUrl5100 + '/totalAccountSurvey/totalAccountSurveyClueList', params); };
export const subAccountList = params => { return axios.post(ajaxUrl5100 + '/totalAccountSurvey/subAccountList', params); };
export const exportClueLists = params => { return axios.post(ajaxUrl5100 + '/totalAccountSurvey/exportClueList', params); };
// 线索导出
export const exportClueList = params => { return axios.post(ajaxUrl5100 + '/organizationClue/exportClueList', params); };
export const exportTaskNumberList = params => { return axios.post(ajaxUrl5100 + '/calltask/exportTaskNumberList', params); };
// 通过通话记录id获取录音对话信息
export const getClueDetail = params => { return axios.post(ajaxUrl5100 + '/organizationClue/getClueDetail' + params); };
export const getTalkTextByRecordId = params => { return axios.post(ajaxUrl5100 + '/organizationClue/getTalkTextByRecordId' + params); };

// 单呼
export const callOut = params => { return axios.post(ajaxUrl5100 + '/callCenter/callOut' + params); };
// 直呼
export const callNumber = params => { return axios.post(ajaxUrl5100 + '/callCenter/callNumber' + params); };
// 最近一批线索导入信息获取
export const getBatchData = params => { return axios.post(ajaxUrl5100 + '/clueImport/getBatchData'); };
// 新 数据统计<按时间 按批次>
export const newDataStatistics = params => { return axios.post(ajaxUrl5100 + '/sales/newDataStatistics', params); };
// 7100
export const bdUserList = params => { return axios.post(ajaxUrl7100 + '/bdUser/bdUserList', params); };
export const createBdUser = params => { return axios.post(ajaxUrl7100 + '/bdUser/createBdUser', params); };
export const operationBdUser = params => { return axios.post(ajaxUrl7100 + '/bdUser/operationBdUser', params); };
export const bdClueList = params => { return axios.post(ajaxUrl7100 + '/bdClue/bdClueList', params); };
export const saveBdClue = params => { return axios.post(ajaxUrl7100 + '/bdClue/saveBdClue', params); };
export const bdClueDetail = params => { return axios.post(ajaxUrl7100 + '/bdClue/bdClueDetail' + params); };
export const bdClueReceive = params => { return axios.post(ajaxUrl7100 + '/bdClue/bdClueReceive' + params); };
export const markSuccessClosed = params => { return axios.post(ajaxUrl7100 + '/bdClue/markSuccessClosed' + params); };
export const submitTrial = params => { return axios.post(ajaxUrl9100 + '/trialinvitation/submitTrial', params); };
/********充值**********/
export const toPayNew = params => { return axios.post(ajaxUrl6100 + '/pay/toPayNew', params); };
export const payList = params => { return axios.post(ajaxUrl6100 + '/organizationAccountRecords/pagelist', params); };
export const aiCountAddList = params => { return axios.post(ajaxUrl6100 + '/organizationAccountRecords/aiCountAddList', params); };
/********充值**********/

/******费用中心******/
export const organizationAccountRecords = params => { return axios.post(ajaxUrl6100 + '/organizationAccountRecords/pagelist', params); };
export const consumptionStatisticsList = params => { return axios.post(ajaxUrl6100 + '/organizationAccountRecords/consumptionStatisticsList', params); };
/******费用中心******/

// websocket收到消息回调
export const callbackWebsocketOnMessage = function (message) {
    console.log(message)
};


// WEBPACK FOOTER //
// ./src/api/index.js


// WEBPACK FOOTER //
// ./src/api/index.js